import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OfferModel, ProductModel } from './../../models/wardrobe.model';
import { OFFER_TYPE_SWAP_REQUEST, SWAP_REQUEST_COIN_PRICE, SWAP_REQUEST_EUR_PRICE } from 'src/app/constants/general.constant';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { OfferService } from 'src/app/services/offer.service';
import { GeneralService } from 'src/app/services/general.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { finalize } from 'rxjs/operators';
import { UserModel } from 'src/app/models/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'shc-swap-request-item-modal',
  templateUrl: './swap-request-item-modal.component.html',
  styleUrls: ['./swap-request-item-modal.component.scss'],
})
export class SwapRequestItemModalComponent implements OnInit {
  form: UntypedFormGroup;
  offer: OfferModel;
  coinsRequired: number = SWAP_REQUEST_COIN_PRICE;
  swapRequestPrice: number = SWAP_REQUEST_EUR_PRICE;
  @Input() sender: UserModel;
  @Input() product: ProductModel;

  constructor(
    private modalCtrl: ModalController,
    private offerService: OfferService,
    private generalService: GeneralService,
    private errorService: ErrorHandlerService,
    private router: Router,
  ) {}

  ngOnInit() {
    console.log("SENDER", this.sender);


    this.form = new UntypedFormGroup({
      product_id: new UntypedFormControl(this.product?.id || null),
      sent_by: new UntypedFormControl(this.sender?.id || null),
      sent_to: new UntypedFormControl(this.product?.user?.id || null),
      offer_type: new UntypedFormControl(OFFER_TYPE_SWAP_REQUEST),
    });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  routeToSubscription() {
    this.modalCtrl.dismiss();
    this.router.navigate(['subscriptions']);
  }

  sendSwapRequest(){
    this.generalService.showLoader();
    this.offerService.createOffer(this.form.value).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      this.offer = res;
      this.modalCtrl.dismiss(this.offer, 'confirm');
    }, error => {
      this.errorService.handle(error);
    });
  }
}
